<template>
  <div class="content">
    <!-- <header v-if="isWX != 0">
      <i class="iconfont icon-home_location_icon_l" @click="returnBack"></i>
      <p>商家注册</p>
    </header> -->
    <h5-header v-if="isWX != 0" :header-msg="headerMsg"></h5-header>
    <van-cell-group ref="vans">
      <van-field v-model="company" label placeholder="请输入公司名称" clearable @input="disable" />
      <!-- <van-field v-model="contacts" label="联系人" placeholder="请输入联系人名称" required clearable /> -->
      <van-field
        v-model="phone"
        type="number"
        label
        placeholder="请输入您的手机号"
        clearable
        maxlength="11"
        @input="disable"
      />
      <van-field
        v-model="smsCode"
        type="number"
        label
        placeholder="请输入验证码"
        clearable
        @input="disable"
      >
        <van-button
          slot="button"
          size="small"
          plain
          type="info"
          @click="getCodes"
          v-show="isGet"
        >获取验证码</van-button>
        <van-button slot="button" size="small" plain type="default" v-show="!isGet">{{num+'s'}}</van-button>
      </van-field>

      <van-field
        v-model="password"
        :type="see?'text':'password'"
        label
        placeholder="请设置6-20位数字+字母的密码"
        clearable
        :right-icon="see?'eye-o':'closed-eye'"
        @click-right-icon="seePassword"
        @input="disable"
      />
      <van-field
        v-model="confirmPassword"
        :type="see?'text':'password'"
        label
        placeholder="请再次输入密码"
        clearable
        :right-icon="see?'eye-o':'closed-eye'"
        @click-right-icon="seePassword"
        @input="disable"
      />
    </van-cell-group>
    <van-checkbox v-model="checked" @change="check" class="texts" label-disabled>
      我已阅读并同意
      <span @click="sellerRule">《悦卖用户协议》</span>和
      <span @click="payText">《手续费费用说明》</span>
    </van-checkbox>

    <van-button type="info" :disabled="disabled" @click="submit">立即提交</van-button>
  </div>
</template>

<script>
import { getCode, infoTwo } from "@/api/join";
// import AddressInfo from "@/components/area.js";
export default {
  data() {
    return {
      phone: "", //联系电话/手机号码(账号和手机号一样)
      company: "", //企业名称
      smsCode: "", //验证码
      password: "", //密码
      confirmPassword: "", //确认密码
      isGet: true, //btn切换的布尔值
      see: false,
      num: Number,
      checked: true, //是否同意
      disabled: true,
      isWX: "1", //判断是否是微信进入。0 是 1 不是
      headerMsg: {
        title: "商家注册",
        url: "/join",
      }
    };
  },
  mounted() {
    //this.getIndustryList();
    this.isWX = this.GetQueryString("wx");
    // console.log(errors.first('企业名称'))
  },
  // beforeUpdate() {
  //   this.isWX = this.GetQueryString("wx")
  // },
  methods: {
    sellerRule() {
      this.$router.push({
        path: "/rule",
        query: {
          type: this.GetQueryString("type"),
          refereeId: this.GetQueryString("refereeId"),
          wx: this.GetQueryString("wx") || "1"
        }
      }); //跳转
    },
    payText() {
      this.$router.push({
        path: "/payText",
        query: {
          type: this.GetQueryString("type"),
          refereeId: this.GetQueryString("refereeId"),
          wx: this.GetQueryString("wx") || "1"
        }
      }); //跳转
    },

    // 提交按钮是否可见
    disable() {
      if (
        this.phone &&
        this.company &&
        this.smsCode &&
        this.password &&
        this.confirmPassword &&
        this.checked
      ) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    // 获取验证码
    getCodes() {
      const phone = this.validates(
        this.phone,
        "手机号不能为空",
        "请输入正确的手机号",
        /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      );
      Promise.all([phone]).then(res => {
        let obj = {
          phone: this.phone,
          type: "1",
          user_type: "1",
          account: this.phone
        };
        getCode(obj).then(res => {
          console.log(res);
          if (res.appStatus.errorCode != 0) {
            this.isGet = true;
            this.$toast(res.appStatus.message);
            return false;
          }
          this.isGet = false;
          this.countDown();
        });
      });
    },

    // 倒计时
    countDown() {
      const that = this;
      that.num = 60;
      let time = setInterval(() => {
        that.num -= 1;
        that.num = that.flot(that.num);
        if (that.num <= 0) {
          that.isGet = true;
          clearInterval(time);
        }
      }, 1000);

      if (that.num <= 0) {
        clearInterval(time);
      }
    },

    // 补0
    flot(num) {
      if (num > 9) {
        return num;
      } else {
        return "0" + num;
      }
    },

    // 打勾
    check(val) {
      //console.log(val);
      this.disable();
      //   this.checked = val
    },
    seePassword() {
      this.see = !this.see;
    },
    // 提交申请
    submit() {
      const company = this.validates(
        this.company.replace(/\s*/g, ""),
        "公司名称不能为空",
        "最大40个字符，20个汉字",
        /^[\u4e00-\u9fa5\w]{1,40}$/
      );
      const smsCode = this.validates(this.smsCode, "验证码不能为空");
      const password = this.validates(
        this.password,
        "密码不能为空",
        "请设置6-20位数字+字母的密码",
        /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){6,20}$/
      );
      const confirmPassword = this.validates(
        this.confirmPassword,
        "请再次输入密码",
        "请设置6-20位数字+字母的密码",
        /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){6,20}$/
      );
      const phone = this.validates(
        this.phone,
        "手机号不能为空",
        "请输入正确的手机号",
        /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      );
      const checked = this.validates(this.checked, "请阅读相关协议并打勾");
      Promise.all([password, confirmPassword, smsCode, company, phone, checked])
        .then(result => {
          // application/x-www-form-urlencoded  格式的传参, a=3&b=4,相当奇葩
          let obj =
            "sellerTypeId=3" +
            "&account=" +
            this.phone +
            "&phone=" +
            this.phone +
            "&company=" +
            this.company.replace(/\s*/g, "") +
            "&smsCode=" +
            this.smsCode +
            "&password=" +
            this.password +
            "&confirmPassword=" +
            this.confirmPassword +
            "&refereeType=2" +
            "&refereeId=" +
            this.GetQueryString("refereeId");

          infoTwo(obj).then(res => {
            if (res.appStatus.errorCode != 0) {
              this.$toast(res.appStatus.message);
              this.smsCode = "";
              return;
            }

            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
              //判断是否是微信环境
              //微信环境
              wx.miniProgram.getEnv(function(res) {
                if (res.miniprogram) {
                  //小程序环境下逻辑
                  this.$router.push({
                    path: "/wxsuccess",
                    query: {
                      type: this.GetQueryString("type"),
                      refereeId: this.GetQueryString("refereeId"),
                      wx:this.GetQueryString('wx') || '1'
                    }
                  });
                } else {
                  //非小程序环境下逻辑
                }
              });
            } else {
              this.$router.push({
                path: "/success",
                query: {
                  type: this.GetQueryString("type"),
                  refereeId: this.GetQueryString("refereeId"),
                  wx:this.GetQueryString('wx') || '1'
                }
              }); //跳转
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
    },

    // 表单验证公共方法
    // val-输入框内容   nullText-为空的提示语  regText-验证失败的提示语  reg-自定义验证规则
    validates(val, nullText, regText, regs) {
      let p = new Promise((resolve, reject) => {
        let reg = regs || /^[.\n]*/;
        if (val == "" || !val) {
          this.$toast({
            title: "提示",
            message: nullText
          });
          reject(false);
        } else if (!reg.test(val)) {
          this.$toast({
            title: "提示",
            message: regText || ""
          });
          reject(false);
        } else if (nullText.indexOf("再次") != -1) {
          if (this.password != this.confirmPassword) {
            this.$toast({
              title: "提示",
              message: "请保持两次输入的密码一致"
            });
            reject(false);
          } else {
            resolve(true);
          }
        } else if (nullText.indexOf("协议") != -1) {
          if (!val) {
            this.$toast({
              title: "提示",
              message: nullText
            });
            reject(false);
          } else {
            resolve(true);
          }
        } else {
          resolve(true);
        }
      });
      return p;
    },

    // 左上角返回按钮
    // returnBack() {
    //   this.$router.push({
    //     path: "/join",
    //     query: {
    //       type: this.GetQueryString("type"),
    //       refereeId: this.GetQueryString("refereeId"),
    //       wx:this.GetQueryString('wx') || '1'
    //     }
    //   }); //跳转
    // }
  }
};
</script>

<style lang="scss" scoped>
.content {
  
  /deep/.van-cell {
    height: 61px;
    line-height: 61px;
    padding: 12px 18px;
    align-items: center;
  }
  /deep/.van-field__label {
    width: 0px;
  }
  /deep/.van-field__control{
    height: 30px;
  }
  /deep/.van-button--normal {
    width: 351px;
    height: 50px;
    background: #1993ff;
    border-color: #1993ff;
    border-radius: 25px;
    position: fixed;
    left: 0;
    right: 0;
    margin: 0 auto;
    // bottom: 20px;
  }
  /deep/.van-button--plain {
    width: 89px;
    height: 34px;
    border: 2px solid rgba(25, 147, 255, 1);
    border-radius: 25px;
    font-size: 14px;
    color: #1993ff;
    padding: 0;
  }
  .van-button--default {
    border: 2px solid #999999;
    color: #999999;
  }
  /deep/.van-field__button {
    display: flex;
  }
  .texts {
    font-size: 12px;
    text-align: center;
    margin: 20px auto 37px;
    width: fit-content;
    span {
      color: #1993ff;
    }
  }
  /deep/.van-cell:not(:last-child)::after {
    right: 20px;
  }
  /deep/.van-icon-closed-eye {
    font-size: 24px;
    color: #333;
  }
  /deep/.van-icon-eye-o {
    font-size: 24px;
    color: #333;
  }
}
</style>
